import Vue from 'vue'
import Vuex, { ActionContext } from 'vuex'
import auth from '#/store/auth'
import { AuthState } from '~/store/auth'
import modal, { ModalState } from '~/store/modal'
import { vuexToken } from '@/store/caches/vuex-persistedstate'
// modules

Vue.use(Vuex)

export interface RootState {
    auth: AuthState
    modal: ModalState
}

// context of the vuex actions
export interface VuexActionData<T> extends ActionContext<T, RootState> {}

export default new Vuex.Store({
    plugins: [vuexToken],
    modules: { auth, modal }
})
